import {useNavigate} from 'react-router-dom';
import Box from '@mui/material/Box';
import { lightBlue } from '@mui/material/colors';
import Button from '@mui/material/Button';
import { FS } from "@plannel/utils/font-util";

const NotFound = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center', 
        bgcolor: lightBlue[300], 
        height: '100%' 
      }}
    >
      <Box sx={{ color: 'white', fontSize: 250 }}>404</Box>
      <Box sx={{ pt: 2, pb: 8, color: 'white', fontSize: FS.KPI }}>The page you are looking for might have been removed.</Box>
      <Button variant="contained" size="large" color='info' onClick={ goBack } >Go Back</Button>
    </Box>
  );
}

export default NotFound;